/**
 * Accusation emission — per CONTRACTS.md, UI accuse buttons emit
 * `player:interact` with a suspect InteractTarget (`id: 'accuse:<suspectId>'`);
 * GAME is the sole emitter of `game:accuse`. Owned by UI.
 */
import type { EventBus, InteractTarget, Vec3 } from '../core/types'
import { ACCUSE_ID_PREFIX, ACCUSE_TARGET_RADIUS_M } from './constants'

export const emitAccusation = (
  bus: EventBus,
  suspectId: string,
  suspectName: string,
  position: Vec3
): void => {
  const target: InteractTarget = {
    id: `${ACCUSE_ID_PREFIX}${suspectId}`,
    kind: 'suspect',
    position,
    radius: ACCUSE_TARGET_RADIUS_M,
    prompt: `Accuse ${suspectName}`,
    suspectId
  }
  bus.emit('player:interact', { target })
}
